// src/pages/cashMovementsMenu.js

import "../styles/cashMovementsMenu.css";
import "../styles/loadingModal.css";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import useAuth from "../components/useAuth";
import FilterField from "../components/salesFilters";
import GenericModal from "../components/filtersModal";
import LoadingModal from "../components/loadingModal";

import homeIcon from "../assets/home-icon.png";

import * as XLSX from "xlsx";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  Legend,
  LabelList
} from "recharts";

export default function CashMovementsMenu() {

  const { userName, clientName } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Galileo Analytics - Movimientos de Caja";
  }, []);

  // =========================================================
  // MODAL
  // =========================================================

  const [modalOpen, setModalOpen] = useState(false);

  const [modalType, setModalType] = useState("");

  const [modalTitle, setModalTitle] = useState("");

  const [modalData, setModalData] = useState([]);

  const [modalLoading, setModalLoading] =
    useState(false);

  const [aperturasCache, setAperturasCache] =
    useState({});

const openFilterModal = async (type) => {

  setModalType(type);

  setModalTitle("Seleccionar " + type);

  setModalOpen(true);

  // =====================================
  // CACHE APERTURAS
  // =====================================

  if (
    type === "apertura" &&
    filtersState.cCaja
  ) {

    const cacheKey =
      `${filtersState.cSucursal}_${filtersState.cCaja}`;

    if (aperturasCache[cacheKey]) {

      setModalData(
        aperturasCache[cacheKey]
      );

      setModalLoading(false);

      return;
    }
  }

  setModalData([]);

  setModalLoading(true);

  try {

    let endpoint =
      "api/cashMovementsFilters.php?filter=" + type;

    if (type === "caja") {

      endpoint +=
        "&cSucursal=" + filtersState.cSucursal;
    }

    if (
      type === "apertura" &&
      filtersState.cCaja
    ) {

      endpoint +=
        "&cCaja=" + filtersState.cCaja;
    }

    const response = await fetch(
      endpoint,
      {
        method: "GET",
        credentials: "include"
      }
    );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

    const text = await response.text();

    try {

      const data = JSON.parse(text);

      setModalData(data);

      // =====================================
      // GUARDAR CACHE APERTURAS
      // =====================================

      if (
        type === "apertura" &&
        filtersState.cCaja
      ) {

        const cacheKey =
          `${filtersState.cSucursal}_${filtersState.cCaja}`;

        setAperturasCache(prev => ({
          ...prev,
          [cacheKey]: data
        }));
      }

    } catch (jsonError) {

      console.error(
        "JSON parse error:",
        text
      );

      setModalData([]);
    }

  } catch (error) {

    console.error(
      "Error cargando datos:",
      error
    );

    setModalData([]);

  } finally {

    setModalLoading(false);
  }
};

  const closeFilterModal = () => {

    setModalOpen(false);

    setModalType("");

    setModalTitle("");
  };

  // =========================================================
  // FILTROS
  // =========================================================

  const filters = [

    {
      label: "Sucursal",
      type: "text",
      name: "sucursal",
      readOnly: true,
      withButton: true,
      onButtonClick: () =>
        openFilterModal("sucursal")
    },

    {
      label: "Caja",
      type: "text",
      name: "caja",
      readOnly: true,
      withButton: true,
      onButtonClick: () =>
        openFilterModal("caja")
    },

    {
      label: "Apertura",
      type: "text",
      name: "apertura",
      readOnly: true,
      withButton: true,
      onButtonClick: () => {

        if (!filtersState.cCaja) {

          alert(
            "Debe seleccionar una caja primero."
          );

          return;
        }

        openFilterModal("apertura");
      }
    }
  ];

  const [filtersState, setFiltersState] =
    useState({

      sucursal: "Central por defecto",
      cSucursal: 0,

      caja: "",
      cCaja: "",

      apertura: "",
      cApertura: ""
    });

  // =========================================================
  // HANDLE SELECT
  // =========================================================

  const handleSelect = (item) => {

    if (!modalType) return;

    const pick = (obj, ...keys) => {

      for (const k of keys) {

        if (obj == null) continue;

        if (
          Object.prototype.hasOwnProperty.call(
            obj,
            k
          )
        ) {
          return obj[k];
        }
      }

      return undefined;
    };

    switch (modalType) {

      case "sucursal": {

        const text =
          pick(item, "sucursal", "SUCURSAL");

        const val =
          pick(item, "cSucursal", "CSUCURSAL");

        setFiltersState(prev => ({
          ...prev,

          sucursal: text ?? "",
          cSucursal: Number(val ?? 0),

          caja: "",
          cCaja: "",

          apertura: "",
          cApertura: ""
        }));
        setAperturasCache({});
        break;
      }

      case "caja": {

        const text =
          pick(
            item,
            "caja",
            "CAJA",
            "nombre",
            "NOMBRE"
          );

        const val =
          pick(
            item,
            "cCaja",
            "CCAJA",
            "id",
            "ID"
          );

        setFiltersState(prev => ({
          ...prev,

          caja: text ?? "",
          cCaja: val ?? "",

          apertura: "",
          cApertura: ""
        }));
        setAperturasCache({});
        break;
      }

      case "apertura": {

        const text =
          pick(
            item,
            "APERTURA_LABEL",
            "apertura",
            "APERTURA"
          );

        const val =
          pick(
            item,
            "CAPERTURA_CIERRE",
            "cApertura",
            "id",
            "ID"
          );

        setFiltersState(prev => ({
          ...prev,

          apertura: text ?? "",
          cApertura: val ?? ""
        }));

        break;
      }

      default:
        break;
    }

    closeFilterModal();
  };

  // =========================================================
  // DATA
  // =========================================================

    const [cashData, setCashData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [sessionInfo, setSessionInfo] = useState({

      fechaApertura: "-",
      usuarioApertura: "-",

      fechaCierre: "-",
      usuarioCierre: "-"
    });

    const [totals, setTotals] = useState({

      ingresos: 0,
      egresos: 0,
      saldo: 0,
      saldoApertura: 0,
      movimientos: 0
    });

    const [conceptStats, setConceptStats] =
      useState([]);

    const [paymentStats, setPaymentStats] =
      useState([]);

  const COLORS = {

    apertura: "#2563eb",
    cierre: "#7c3aed",

    ingreso: "#16a34a",
    egreso: "#dc2626"
  };

  // =========================================================
  // COLOR POR CONCEPTO
  // =========================================================

  const getConceptColor = (item) => {

    const conceptoId =
      Number(item.CCONCEPTO_MOV_CAJA);

    if (conceptoId === 1) {
      return COLORS.apertura;
    }

    if (conceptoId === 2) {
      return COLORS.cierre;
    }

    const compareValue =
      item.originalValue ?? item.value;

    return compareValue >= 0
      ? COLORS.ingreso
      : COLORS.egreso;
  };

  // =========================================================
  // LIMPIAR FILTROS
  // =========================================================

  const clearFilters = () => {

    setFiltersState({

      sucursal: "",
      cSucursal: "",

      caja: "",
      cCaja: "",

      apertura: "",
      cApertura: ""
    });

    setCashData([]);

    setConceptStats([]);

    setPaymentStats([]);

    setTotals({

      ingresos: 0,
      egresos: 0,
      saldo: 0,
      saldoApertura: 0,
      movimientos: 0
    });
  };

  // =========================================================
  // UTILIDADES
  // =========================================================

  const formatMoney = (value) => {

    return Number(value || 0)
      .toLocaleString(
        "es-AR",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      );
  };

  // =========================================================
  // BUILD CHART DATA
  // =========================================================

    const buildConceptStats = (data) => {

      const map = {};

      data.forEach(item => {

        const concept =
          item.CONCEPTO ||
          "Sin Concepto";

        const ingreso =
          Number(item.MONTO_INGRESADO || 0);

        const egreso =
          Number(item.MONTO_RETIRADO || 0);

        const total =
          ingreso - egreso;

        const conceptoId =
          Number(item.CCONCEPTO_MOV_CAJA);

        if (!map[concept]) {

          map[concept] = {

            name: concept,

            value: 0,

            order:
              conceptoId === 1
                ? 1
                : conceptoId === 2
                  ? 4
                  : total >= 0
                    ? 2
                    : 3,

            CCONCEPTO_MOV_CAJA:
              conceptoId
          };
        }

        map[concept].value += total;
      });

      return Object.values(map)

        .filter(x => x.value !== 0)

        .sort((a, b) => {

          if (a.order !== b.order) {
            return a.order - b.order;
          }

          return (
            Math.abs(b.value) -
            Math.abs(a.value)
          );
        });
    };

  const buildPaymentStats = (data) => {

    const map = {};

    data.forEach(item => {

      const concepto =
        Number(item.CCONCEPTO_MOV_CAJA);

      // ignorar apertura y cierre
      if (
        concepto === 1 ||
        concepto === 2
      ) {
        return;
      }

      const tipoPago =
        item.TIPO_PAGO ||
        "Pago sin Identificar";

      const importe =
        Number(item.MONTO_INGRESADO || 0) -
        Number(item.MONTO_RETIRADO || 0);

      if (!map[tipoPago]) {

        map[tipoPago] = {

          name: tipoPago,
          value: 0
        };
      }

      map[tipoPago].value += importe;
    });

    return Object.values(map)

      .filter(x => x.value !== 0)

      .sort(
        (a, b) =>
          Math.abs(b.value) -
          Math.abs(a.value)
      );
  };

  // =========================================================
  // APPLY FILTERS
  // =========================================================

  const handleApplyFilters = async (e) => {

    e.preventDefault();

    if (!filtersState.cCaja) {

      alert("Debe seleccionar una caja.");

      return;
    }

    if (!filtersState.cApertura) {

      alert(
        "Debe seleccionar una apertura."
      );

      return;
    }

    setLoading(true);

    setCashData([]);

    try {

      const filtros = {

        cCaja: filtersState.cCaja,
        cApertura:
          filtersState.cApertura
      };

      const response = await fetch(
        "api/cashMovementsList.php",
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json"
          },

          credentials: "include",

          body: JSON.stringify(filtros)
        }
      );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

      const text =
        await response.text();

      let data = [];

      try {

        data = JSON.parse(text);
        //console.log(data);
        //console.log(data.slice(0,10));
      } catch (e) {

        console.error(
          "Error parseando JSON:",
          e
        );

        setLoading(false);

        return;
      }

      setCashData(data);

      // ======================================
      // APERTURA / CIERRE
      // ======================================

      const aperturaMovimiento =
        data.find(
          x =>
            Number(
              x.CCONCEPTO_MOV_CAJA
            ) === 1
        );

      const cierreMovimiento =
        data.find(
          x =>
            Number(
              x.CCONCEPTO_MOV_CAJA
            ) === 2
        );

      // ======================================
      // SESSION INFO
      // ======================================

      setSessionInfo({

        fechaApertura:
          aperturaMovimiento
            ?.FECHA_APERTURA || "-",

        usuarioApertura:
          aperturaMovimiento
            ?.USUARIO || "-",

        fechaCierre:
          cierreMovimiento
            ?.FECHA_CIERRE || "-",

        usuarioCierre:
          cierreMovimiento
            ?.USUARIO || "-"
      });

      // ======================================
      // EXCLUIR APERTURA / CIERRE
      // ======================================

      const movimientosReales =
        data.filter(item => {

          const concepto =
            Number(
              item.CCONCEPTO_MOV_CAJA
            );

          return (
            concepto !== 1 &&
            concepto !== 2
          );
        });

      // ======================================
      // SALDO APERTURA
      // ======================================

      const saldoApertura =
        Number(
          aperturaMovimiento
            ?.MONTO_INGRESADO || 0
        );

      // ======================================
      // SALDO FINAL
      // ======================================

      let saldoFinal = 0;

      if (cierreMovimiento) {

        saldoFinal =
          Number(
            cierreMovimiento.MONTO_RETIRADO || 0
          );

      } else {

        const ultimoMovimiento =
          data[data.length - 1];

        saldoFinal =
          Number(
            ultimoMovimiento?.SALDO || 0
          );
      }

      // ======================================
      // INGRESOS
      // ======================================

      const ingresos =
        movimientosReales.reduce(
          (acc, item) =>
            acc +
            Number(
              item.MONTO_INGRESADO || 0
            ),
          0
        );

      // ======================================
      // EGRESOS
      // ======================================

      const egresos =
        movimientosReales.reduce(
          (acc, item) =>
            acc +
            Number(
              item.MONTO_RETIRADO || 0
            ),
          0
        );

      // ======================================
      // TOTALS
      // ======================================

      setTotals({

        ingresos,

        egresos,

        saldo: saldoFinal,

        saldoApertura,

        movimientos: data.length
      });

      // ======================================
      // CHARTS
      // ======================================

      setConceptStats(
        buildConceptStats(data)
      );

      setPaymentStats(
        buildPaymentStats(data)
      );

      setLoading(false);

    } catch (error) {

      console.error(
        "Error obteniendo movimientos:",
        error
      );

      setLoading(false);
    }
  };

  // =========================================================
  // EXPORT EXCEL
  // =========================================================

  const exportToExcel = () => {

    if (
      !cashData ||
      cashData.length === 0
    ) {

      alert(
        "No hay datos para exportar."
      );

      return;
    }

    const headers = [
      "Fecha Movimiento",
      "Concepto",
      "Monto Ingresado",
      "Monto Retirado",
      "Saldo",
      "Tipo de Pago",
      "Usuario"
    ];

    const rows = cashData.map(row => [

      row.FECHA_MOVIMIENTO,
      row.CONCEPTO,
      Number(row.MONTO_INGRESADO),
      Number(row.MONTO_RETIRADO),
      Number(row.SALDO),
      row.TIPO_PAGO,
      row.USUARIO

    ]);

    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.aoa_to_sheet([
      headers,
      ...rows
    ]);

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Movimientos Caja"
    );

    XLSX.writeFile(
      wb,
      "Galileo-Analytics-Movimientos-Caja.xlsx"
    );
  };

/*
  const COLORS = [
    "#0077b6",
    "#00b4d8",
    "#48cae4",
    "#90e0ef",
    "#023e8a",
    "#0096c7",
    "#03045e",
    "#06d6a0",
    "#118ab2",
    "#073b4c"
  ];*/

  // =========================================================
  // PIE DATA
  // =========================================================

  const pieData =
    conceptStats
      .filter(
        item =>
          Math.abs(item.value) > 0
      )
      .map(item => ({
        ...item,

        // valor visual
        value: Math.abs(item.value),

        // conservar signo original
        originalValue: item.value
      }));

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>

      <div className="sales-menu">

        {/* FILTROS */}

        <aside className="filters-section">

          <div className="filters-header">

            <button
              type="button"
              className="home-button"
              onClick={() =>
                navigate("/menu")
              }
            >
              <img
                src={homeIcon}
                alt="Home"
              />
            </button>

          </div>

          <h2>Filtros</h2>

          <form
            className="sales-filters-form"
            onSubmit={handleApplyFilters}
          >

            <div className="filters-body">

              {filters.map((f) => {

                let hiddenVal = "";

                if (f.name === "caja") {

                  hiddenVal =
                    filtersState.cCaja || "";
                }
                else if (
                  f.name === "apertura"
                ) {

                  hiddenVal =
                    filtersState.cApertura || "";
                }

                return (

                  <FilterField
                    key={f.name}
                    {...f}
                    value={
                      filtersState[
                        f.name
                      ] || ""
                    }
                    hiddenValue={hiddenVal}
                    onChange={(e) => {

                      const value =
                        e.target.value;

                      setFiltersState(prev => ({
                        ...prev,
                        [f.name]: value
                      }));
                    }}
                  />
                );
              })}

            </div>

            <button
              type="submit"
              className="filter-button"
            >
              Aplicar Filtros
            </button>

            <button
              type="button"
              className="delete-filter-button"
              onClick={clearFilters}
            >
              Borrar Filtros
            </button>

            <button
              type="button"
              className="export-excel-button"
              onClick={exportToExcel}
            >
              Exportar Datos
            </button>

          </form>

        </aside>

        {/* DASHBOARD */}

        <main className="sales-data">

          {/* INFO SESION */}

          <div className="stats-cards">

            <div className="stat-card">
              <span>Fecha Apertura</span>

              <h2 style={{ fontSize: "1.1rem" }}>
                {sessionInfo.fechaApertura}
              </h2>
            </div>

            <div className="stat-card">
              <span>Usuario Apertura</span>

              <h2 style={{ fontSize: "1.1rem" }}>
                {sessionInfo.usuarioApertura}
              </h2>
            </div>

            <div className="stat-card">
              <span>Fecha Cierre</span>

              <h2 style={{ fontSize: "1.1rem" }}>
                {sessionInfo.fechaCierre}
              </h2>
            </div>

            <div className="stat-card">
              <span>Usuario Cierre</span>

              <h2 style={{ fontSize: "1.1rem" }}>
                {sessionInfo.usuarioCierre}
              </h2>
            </div>

            <div className="stat-card">
              <span>Movimientos</span>

              <h2>
                {totals.movimientos}
              </h2>
            </div>

          </div>

          {/* CHARTS */}

<div className="charts-grid">

  {/* BARRAS */}

  <div className="chart-card">

    <div className="chart-title">
      Movimientos por Concepto
    </div>

    <div className="chart-wrapper">

      <ResponsiveContainer
        width="100%"
        height="100%"
      >

        <BarChart
          data={conceptStats}
          margin={{
            top: 20,
            right: 20,
            left: 50,
            bottom: 40
          }}
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            dataKey="name"
            interval={0}
            angle={-10}
            textAnchor="end"
            height={70}
            tick={{
              fontSize: 11
            }}
          />

          <YAxis
            width={90}
            tickFormatter={(v) =>
              `$${formatMoney(v)}`
            }
          />

          <Tooltip
            formatter={(value) =>
              `$${formatMoney(value)}`
            }
          />

          <Bar
            dataKey="value"
            radius={[8, 8, 0, 0]}
          >

            {conceptStats.map(
              (entry, index) => (

                <Cell
                  key={index}
                  fill={getConceptColor(entry)}
                />
              )
            )}

          </Bar>

        </BarChart>

      </ResponsiveContainer>

    </div>

  </div>

  {/* PIE */}

  <div className="chart-card">

    <div className="chart-title">
      Distribución de Conceptos
    </div>

    <div className="chart-wrapper">

      <ResponsiveContainer
        width="100%"
        height="100%"
      >

        <PieChart>

          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="45%"
            outerRadius={110}
            innerRadius={40}
            label={false}
          >

            {pieData.map(
              (entry, index) => (

                <Cell
                  key={index}
                  fill={getConceptColor(entry)}
                />
              )
            )}

          </Pie>

          <Tooltip
            formatter={(value) =>
              `$${formatMoney(value)}`
            }
          />

          <Legend
            verticalAlign="bottom"
            height={36}
          />

        </PieChart>

      </ResponsiveContainer>

    </div>

  </div>

  {/* TIPOS DE PAGO */}

  <div className="chart-card">

    <div className="chart-title">
      Tipos de Pago
    </div>

    <div
      className="chart-wrapper"
      style={{ height: "450px" }}
    >

      <ResponsiveContainer
        width="100%"
        height="100%"
      >

        <BarChart
          layout="vertical"
          data={paymentStats}
          margin={{
            top: 20,
            right: 80,
            left: 120,
            bottom: 20
          }}
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            type="number"
            tickFormatter={(v) =>
              `$${formatMoney(v)}`
            }
          />

          <YAxis
            type="category"
            dataKey="name"
            width={120}
          />

          <Tooltip
            formatter={(value) =>
              `$${formatMoney(value)}`
            }
          />

          <Bar
            dataKey="value"
            fill="#2563eb"
            radius={[0, 8, 8, 0]}
          >

            <LabelList
              dataKey="value"
              position="right"
              formatter={(v) =>
                `$${formatMoney(v)}`
              }
            />

          </Bar>

        </BarChart>

      </ResponsiveContainer>

    </div>

  </div>

</div>
          {/* RESUMEN */}

          <div className="summary-card">

            <h3>Resumen de Caja</h3>

            <div className="summary-grid">

              <div>
                <span>Saldo Apertura</span>
                <strong>
                  $
                  {formatMoney(
                    totals.saldoApertura
                  )}
                </strong>
              </div>

              <div>
                <span>Total Ingresos</span>
                <strong>
                  $
                  {formatMoney(
                    totals.ingresos
                  )}
                </strong>
              </div>

              <div>
                <span>Total Egresos</span>
                <strong>
                  $
                  {formatMoney(
                    totals.egresos
                  )}
                </strong>
              </div>

              <div>
                <span>Saldo Final</span>
                <strong>
                  $
                  {formatMoney(
                    totals.saldo
                  )}
                </strong>
              </div>

              <div>
                <span>Cantidad Movimientos</span>
                <strong>
                  {totals.movimientos}
                </strong>
              </div>

            </div>

          </div>

        </main>

      </div>

      {/* FOOTER */}

      <div className="sales-menu-footer">

      <div className="footer-left-logo">

        <img
          className="footer-system-logo"
          src={`${process.env.PUBLIC_URL}/logos/galileoinsight-logo.png`}
          alt="Logo Sistema"
        />

      </div>

        <footer>

          <span>
            Sesión Actual:
            {" "}
            {userName}
            {" | "}
            {clientName}
          </span>

        </footer>

      </div>

      {/* MODAL */}

      <GenericModal
        title={modalTitle}
        isOpen={modalOpen}
        data={modalData}
        loading={modalLoading}
        onSelect={handleSelect}
        onClose={closeFilterModal}
      />

      <LoadingModal open={loading} />

    </>
  );
}